import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { RouteFoundPage } from '../route-found.page';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { RouteService } from 'src/app/services/routes/route.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TruckService } from 'src/app/services/truck/truck.service';

@Component({
  selector: 'app-send-detail',
  templateUrl: 'send-detail.page.html',
  styleUrls: ['../route-found.page.scss']
})
export class SendDetailPage extends RouteFoundPage {

  constructor(
    protected location: Location,
    protected spinner: SpinnerService,
    protected auth: AuthService,
    protected profile: ProfileService,
    protected routeService: RouteService,
    protected alert: AlertService,
    protected router: Router,
    protected truckService: TruckService,
    protected activatedRoute: ActivatedRoute,
  ) {
    super(location, spinner, auth, profile, routeService, alert, router, truckService, activatedRoute);
  }

}
